// Información de build generada automáticamente
export const BUILD_DATE = '30-04-2026 20:22:39';
export const BUILD_HASH = 'xegej7zpkw';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1777591359233;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '30-04-2026 20:22:39',
  buildHash: 'xegej7zpkw',
  appVersion: '0.0.0',
  timestamp: 1777591359233
});
